import nn from '../../../global/js/nn';
import LibLoader from './LibLoader';

nn.component.LibLoader = LibLoader;

nn.handlers.init.LibLoader = function () {
  nn.helpers.libLoader = new LibLoader();
};
